module.exports = __webpack_public_path__ + "img/氨气.a436094a.png";